const color = {
  color_1: '#ffffff',
  color_2: '#8a929b',
  color_3: '#818286',
  color_4: '#2f2f33',
  color_5: '#fbfbfd',
  color_6: '#eff2f8',
  color_7: '#a7a7a7',
  color_8: '#000000',
  color_9: '#757a7e',
  color_10: '#00000014',
  color_11: 'f0f2f5'
}

export const light: any = {
  sidemenu: {
    borderColor: color.color_2,
    primaryBackground: color.color_5,
    primaryText: color.color_2
  },
  content: {
    boxShadow: color.color_7,
    primaryText: color.color_8,
    secondaryText: color.color_9,
    borderColor: color.color_10,
    iconColor: color.color_1,
    primaryBackground: color.color_5,
    secondaryBackground: color.color_6,
    ternaryBackground: color.color_11
  },
  input: {
    primary: color.color_2,
    secondary: color.color_1
  },
  background: {
    primary: color.color_4,
    secondary: color.color_4

  },
  text: {
    primary: color.color_1
  },

}